import { $, $$ } from '@utils';
import Collapsable from '@elements/Collapsable/Collapsable';

function init() {
  if (!$('[data-au-pagination]')) return;

  initPagination();
}

function initPagination() {
  const lengthCondition = $$('[data-au-pagination-item]').length > 8;

  if (lengthCondition) {
    collapsePaginations();
    dataLayerPaginationOverflow();
  }
}

function collapsePaginations() {
  const numOfVisibleItems = 5;
  const paginationItems = $$('[data-au-pagination-item]');
  const activeElement = $('[data-au-pagination-item-active]');
  // Get the index of the active element
  const activeIndex = Array.from(paginationItems).indexOf(activeElement);
  // Calculate the number of elements to the beginning and end of the list
  const toBegin = activeIndex; // Number of elements before the active element
  const toEnd = paginationItems.length - activeIndex - 1; // Number of elements after the active element
  let collapseIndex1;
  let collapseIndex2;

  // begin
  if (toBegin < numOfVisibleItems - 1) {
    collapseIndex1 = toBegin >= 3 ? 5 : 4;
    collapseIndex2 = toBegin >= 3 ? 3 : numOfVisibleItems - toBegin;

    createCollapsable(collapseIndex1);
    for (let i = 0; i < toEnd - collapseIndex2; i++) {
      insertPaginationInCollapsable(collapseIndex1);
    }
  }

  // middle
  if (toBegin >= numOfVisibleItems - 1 && toEnd >= numOfVisibleItems - 1) {
    // first collapsable
    createCollapsable(1);
    for (let i = 0; i < toBegin - 3; i++) {
      insertPaginationInCollapsable(1);
    }

    // last collapsable
    createCollapsable2(4);
    for (let i = 0; i < toEnd - 3; i++) {
      insertPaginationInCollapsable2(4);
    }
  }

  // end
  if (toEnd < numOfVisibleItems - 1) {
    collapseIndex2 = toEnd >= 3 ? 3 : numOfVisibleItems - toEnd;

    createCollapsable(1);

    for (let i = 0; i < toBegin - collapseIndex2; i++) {
      insertPaginationInCollapsable(1);
    }
  }
}

function createCollapsable(elIndex) {
  const container = $$('[data-au-pagination-item]')[elIndex];
  const containerClone = container.cloneNode(true);
  const collapsableClone = $('[data-au-pagination-collapsable-1]').content.cloneNode(true);

  removeAttrItem([container, containerClone]);
  container.dataset.auPaginationsContainer = '';
  container.innerHTML = '';
  container.appendChild(collapsableClone);
  $('[data-au-pagination-collapsable-list]').appendChild(containerClone);
  Collapsable.init('[data-au-pagination-collapsable-title]');
}

function createCollapsable2(elIndex) {
  const container = $$('[data-au-pagination-item]')[elIndex];

  const containerClone = container.cloneNode(true);
  const collapsableClone = $('[data-au-pagination-collapsable-2]').content.cloneNode(true);

  removeAttrItem([container, containerClone]);
  container.dataset.auPaginationsContainer = '';
  container.innerHTML = '';
  container.appendChild(collapsableClone);
  $('[data-au-pagination-collapsable-list-2]').appendChild(containerClone);
  Collapsable.init('[data-au-pagination-collapsable-title-2]');
}

function insertPaginationInCollapsable(elIndex) {
  const paginationToMove = $$('[data-au-pagination-item]')[elIndex];

  removeAttrItem([paginationToMove]);
  $('[data-au-pagination-collapsable-list]').appendChild(paginationToMove);
}

function insertPaginationInCollapsable2(elIndex) {
  const paginationToMove = $$('[data-au-pagination-item]')[elIndex];

  removeAttrItem([paginationToMove]);
  $('[data-au-pagination-collapsable-list-2]').appendChild(paginationToMove);
}

function removeAttrItem(elems) {
  elems.forEach((elem) => elem.removeAttribute('data-au-pagination-item'));
}

function dataLayerPaginationOverflow() {
  $$('[data-au-paginations-container] [data-au-collapsable]').forEach((overflow) => {
    overflow.addEventListener('click', () => {
      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickEnlace',
        item_id: 'overflow',
      });
    });
  });
}

export default { init };
